import 'antd/dist/antd.css';

import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Input,
  Message,
  Pagination,
  Select,
  Switch,
  Table,
} from '@alifd/next';
import { Form, Radio, Upload } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import useSWR from 'swr';

import LoadingSpin from '@/components/UI/LoadingSpin';
import client from '@/lib/feathers';

import EditCategories from '../EditCategories';
import { fetchAnnouncementList } from './helpers';
import styles from './index.module.scss';
import { useAnnouncementListFetcherParams } from './useAnnouncementListFetcherParams';

const { RangePicker } = DatePicker;

const AnnouncementList = () => {
  const [form] = Form.useForm();

  // residentAccountNumbers 戶號Table
  const residentAccountNumbers = client.service('residentAccountNumbers');
  // categoryMenu 全域公告類別Table
  const categoryMenu = client.service('categoryMenu');
  // announcement 公告Table
  const announcement = client.service('announcement');
  // 公播列表
  const broadcast = client.service('broadcast');
  // 公播盒列表
  const broadcastBox = client.service('broadcastBoxs');
  // 行事曆
  const calendar = client.service('calendar');
  const [categoryDataArr, setCategoryDataArr] = useState([]);
  const [addAnnouncementDialog, setAnnouncementDialog] = useState(false);
  const [allows, setAllows] = useState([]);

  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [messageStatus, setMessageStatus] = useState(false);
  const [userName, setUserName] = useState('');

  // sort
  const [currentDataIndex, setCurrentDataIndex] = useState('createdTime');
  const [currentOrder, setCurrentOrder] = useState('desc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);

  // preview
  const [previewSingleDialog, setPreviewSingleDialog] = useState(false);

  // 公播
  const [broadcastData, setBroadcastData] = useState([]);
  const [broadcastStatus, setBroadcastStatus] = useState(false);

  // 圖片多檔上傳
  const [addAnnouncementType, setAddAnnouncementType] = useState('');
  const [addAnnouncementDataType, setAddAnnouncementDataType] = useState('');
  const [updateAnnouncementObj, setUpdateAnnouncementObj] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [addAnnouncementId, setAddAnnouncementId] = useState('');
  const [showAnnouncement, setShowAnnouncement] = useState({});
  const [announcementFile, setAnnouncementFile] = useState([]);
  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  const [broadcastGroup, setBroadcastGroup] = useState('one');
  const [announcementTime, setAddAnnouncementTime] = useState('');

  const [announcementType, setAnnouncementType] = useState(undefined);
  const [announcementStatus, setAnnouncementStatus] = useState(undefined);
  const [currentInputKeyword, setCurrentInputKeyword] = useState('');
  const [currentAnnouncementDateRange, setCurrentAnnouncementDateRange] =
    useState([]);

  const fetcherRequiredFieldObject = {
    announcementType,
    currentInputKeyword,
    currentAnnouncementDateRange,
    announcementStatus,
    currentPage,
    currentDataIndex,
    currentOrder,
  };

  const fetcherRequestParams = useAnnouncementListFetcherParams(
    fetcherRequiredFieldObject
  );

  const {
    data: fetcherResponse,
    isLoading,
    mutate,
  } = useSWR(fetcherRequestParams, fetchAnnouncementList);

  useEffect(() => {
    setCurrentPage(1);
  }, [fetcherRequestParams.keyword]);

  useEffect(() => {
    if (user.userGroup.key) {
      console.log(user);
      const checkedKeys = user.userGroup.key.checkedKeys;

      // console.log('checkedKeys', checkedKeys);
      setAllowedFuncs(checkedKeys);
    }
  }, [user]);

  useEffect(() => {
    (async () => {
      const AccountNumbersArr = await residentAccountNumbers.find({});
      setResidentAccountNumbersArr(AccountNumbersArr.data);
      const reAuthenticate = await client.reAuthenticate();
      setUserName(reAuthenticate.user.name);
      const broadcastArr = await broadcast.find({
        query: { broadcastGroup: { $exists: true } },
      });
      setBroadcastData(broadcastArr.data);

      const categoryData = await categoryMenu.find({
        query: { service: 'announcement' },
      });
      setCategoryDataArr(categoryData.data[0].data);
      mutate();
    })();
  }, [
    isUpdate,
    residentAccountNumbers,
    broadcast,
    announcement,
    categoryMenu,
    mutate,
  ]);

  if (isLoading) {
    return <LoadingSpin />;
  }

  const { data: announcementList, total } = fetcherResponse;

  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setCurrentDataIndex(dataIndex);
    setCurrentOrder(order);
  };

  // 推播棟別
  function allowsCheckBox() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      // let householdNumber = residentAccountNumbersArr[i].householdNumber;
      let obj = dataSource.find((item) => item.label === building);
      if (!obj) {
        obj = {
          value: `${building}`,
          label: `${building}`,
        };
        dataSource.push(obj);
      }
    }

    return dataSource;
  }

  // 日期格式處理
  const disabledDate = (date) => {
    return date.startOf('d').valueOf() < moment().startOf('d').valueOf();
  };

  // 新增公播
  const onAddBroadcast = async (value, announcementId) => {
    // 新增至公播清單中
    let newBroadcastData = '';
    const newChildren = [];

    for (let i = 0; i < value.files.length; i++) {
      newChildren.push({
        typeContent: 'image',
        typeFormat: value.files[i].response.showPath,
        textSize: 'originalSize',
        textTags: '',
        textColor: '',
        textLevel: 'center',
        textVertical: 'center',
        unit: 's',
        seconds: 10,
      });
    }
    console.log('newChildren:', newChildren);

    const newBroadcast = {
      title: value.title,
      backgroundMusic: null,
      userName,
      template: 'one',
      announcementId,
      content: [
        {
          carousel: true,
          color: '#FFFFFF',
          size: 100,
          children: [...newChildren],
        },
      ],
    };
    console.log('==newBroadcast:', newBroadcast);

    // 新增公播資料
    const res = await broadcast.create(newBroadcast);
    newBroadcastData = res;
    Message.success('新增至公播清單中');

    // 更新公播群組
    console.log(broadcastGroup);
    if (broadcastGroup === 'more') {
      const res = await broadcast.find({
        query: { _id: value.broadcastGroupId },
      });
      console.log(res, '===res');
      const newBroadcastGroup = res.data[0];

      newBroadcastGroup.broadcastGroupId.push(newBroadcastData._id);
      newBroadcastGroup.broadcastGroup.push(newBroadcastData);
      newBroadcastGroup.broadcastContent.push({
        label: newBroadcastData.title,
        value: newBroadcastData._id,
        content: newBroadcastData,
      });
      console.log(newBroadcastGroup, '===newBroadcastGroup');
      await broadcast.update(value.broadcastGroupId, newBroadcastGroup);

      // 更新至公播盒
      const res2 = await broadcastBox.find({
        query: { broadcastId: value.broadcastGroupId },
      });

      if (res2.data.length > 0) {
        const promise = [];
        for (let i = 0; i < res.data.length; i++) {
          const newRecord = {
            broadcastId: value.broadcastGroupId,
            broadcastBoxsId: [res.data[i]._id],
          };

          promise.push(
            axios('/ezcon/api/enableBroadcast', {
              method: 'POST',
              headers: {
                authorization: window.localStorage['feathers-jwt'],
              },
              data: newRecord,
            })
          );
        }
        await Promise.all(promise);
      }
    }
  };

  // 圖片檔案上傳
  const uploadFiles = (dbName, file) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      `/newUploads?type=${dbName}&isConvertPng=true`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    // 若為圖片新增一份給公播使用
    if (addAnnouncementType === 'img') {
      axios.post('/newUploads?type=announceBroadcast', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      });
    }

    return res;
  };

  // 圖片刪除
  const deleteFile = (file) => {
    return client.service('uploads').remove(file.response._id);
  };

  // 新增修改公告
  const onFinish = async (values) => {
    const value = JSON.parse(JSON.stringify(values));
    console.log(value);
    let newData = {
      ...value,
      updatedTime: moment().valueOf(),
      endTime: moment(value.endTime).valueOf(),
      announcementTime: moment(value.announcementTime).valueOf(),
      allows,
      broadcastStatus,
      broadcastGroup,
      announcer: userName,
    };
    if (!Object.prototype.hasOwnProperty.call(value, 'broadcastGroupId'))
      newData = { ...newData, broadcastGroupId: null };
    if (!Object.prototype.hasOwnProperty.call(value, 'MessageStatus'))
      newData = { ...newData, MessageStatus: false };
    if (!Object.prototype.hasOwnProperty.call(value, 'checkedStatus'))
      newData = { ...newData, checkedStatus: false };
    if (!Object.prototype.hasOwnProperty.call(value, 'content'))
      newData = { ...newData, content: '' };
    if (!Object.prototype.hasOwnProperty.call(value, 'files'))
      newData = { ...newData, files: [] };
    if (value.broadcastStatus === false)
      newData = { ...newData, broadcastGroupId: null };
    if (
      !Object.prototype.hasOwnProperty.call(value, 'calendarStatus') ||
      !value.calendarStatus
    )
      newData = { ...newData, calendarStatus: false, calendarId: null };
    if (!Object.prototype.hasOwnProperty.call(value, 'endTime'))
      newData = { ...newData, endTime: null };

    console.log(newData, 'newData');

    let announcementId = '';
    let newCalendar = {
      selectTime: moment(value.announcementTime).valueOf(),
      title: value.title,
      files: value.files ? value.files : [],
      content: value.content ? value.content : '',
      allows,
      fileType: value.fileType,
    };
    if (addAnnouncementDataType === 'insert') {
      // 新增至行事曆
      if (value.calendarStatus) {
        if (!Object.prototype.hasOwnProperty.call(value, 'MessageStatus'))
          newCalendar = { ...newCalendar, calendarStatus: false };

        const res = await calendar.create(newCalendar);
        newData = { ...newData, calendarId: res._id };
      }

      const res = await announcement.create({
        ...newData,
      });
      Message.success('新增成功');
      setAnnouncementDialog(false);
      setIsUpdate((pre) => !pre);
      announcementId = res._id;

      if (broadcastStatus && broadcastGroup) {
        await onAddBroadcast(value, announcementId);
      }
    } else if (addAnnouncementDataType === 'update') {
      // 行事曆 ====
      if (updateAnnouncementObj.calendarStatus && !value.calendarStatus) {
        await calendar.remove(updateAnnouncementObj.calendarId);
        newData.calendarId = null;
      } else if (
        !updateAnnouncementObj.calendarStatus &&
        value.calendarStatus
      ) {
        const res = await calendar.create(newCalendar);
        newData = { ...newData, calendarId: res._id };
      } else if (updateAnnouncementObj.calendarStatus && value.calendarStatus) {
        const calendarArr = await calendar.find({
          _id: updateAnnouncementObj.calendarId,
        });
        await calendar.update(updateAnnouncementObj.calendarId, {
          ...calendarArr.data[0],
          ...newCalendar,
        });
        newData.calendarId = updateAnnouncementObj.calendarId;
      }

      // 公告===
      const res = await announcement.update(addAnnouncementId, {
        ...updateAnnouncementObj,
        ...newData,
      });
      Message.success('更新成功');
      setAnnouncementDialog(false);
      setIsUpdate((pre) => !pre);
      announcementId = res._id;

      // 公播 ====
      if (
        updateAnnouncementObj.broadcastStatus === true &&
        broadcastStatus === false
      ) {
        const broadcastId = await broadcast.find({
          query: { announcementId },
        });
        if (updateAnnouncementObj.broadcastStatus)
          await broadcast.remove(broadcastId.data[0]._id);
      }
      // 新增至公播清單中
      if (broadcastStatus && broadcastGroup) {
        const broadcastId = await broadcast.find({
          query: { announcementId },
        });
        if (updateAnnouncementObj.broadcastStatus)
          await broadcast.remove(broadcastId.data[0]._id);
        await onAddBroadcast(value, announcementId);
      }
    }
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  return (
    <>
      {/* 公告類別 */}

      {/* 查看 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={previewSingleDialog}
        footer={
          <Button
            type="primary"
            onClick={() => {
              setPreviewSingleDialog(false);
            }}
          >
            關閉
          </Button>
        }
        onCancel={() => {
          setPreviewSingleDialog(false);
        }}
        onClose={() => {
          setPreviewSingleDialog(false);
        }}
      >
        <div className={styles.column}>
          <div className={styles.columnTitle}>公告時間</div>
          <div className={styles.columnText}>
            {moment(showAnnouncement.announcementTime).format(
              'YYYY-MM-DD HH:mm'
            )}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>公告類別</div>
          <div className={styles.columnText}>{showAnnouncement.type}</div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>標題</div>
          <div className={styles.columnText}>{showAnnouncement.title}</div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>狀態</div>
          <div className={styles.columnText}>
            {showAnnouncement.endTime > moment().valueOf() ||
            showAnnouncement.endTime === null
              ? '未截止'
              : '已截止'}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>內容</div>
          <div className={styles.columnText}>
            {showAnnouncement.content !== ''
              ? showAnnouncement.content
              : '無資料'}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>是否置頂</div>
          <div className={styles.columnText}>
            {showAnnouncement.checkedStatus ? '是' : '否'}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>檔案</div>
          <div className={styles.columnText}>
            {showAnnouncement?.files?.length > 0
              ? showAnnouncement.files.map((list, index) => {
                  return (
                    <a
                      style={
                        list === '' ? { display: 'none' } : { display: 'block' }
                      }
                      target="_blank"
                      rel="noreferrer"
                      key={index}
                      href={list.response.showPath}
                    >
                      <span role="img" aria-label="spin" aria-labelledby="">
                        📎
                      </span>
                      {` 附件${index + 1}`}
                    </a>
                  );
                })
              : '無資料'}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>公告截止時間</div>
          <div className={styles.columnText}>
            {showAnnouncement.endTime
              ? moment(showAnnouncement.endTime).format('YYYY-MM-DD HH:mm')
              : '無'}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>公告建立時間</div>
          <div className={styles.columnText}>
            {moment(showAnnouncement.createdTime).format('YYYY-MM-DD HH:mm:ss')}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnTitle}>公告更新時間</div>
          <div className={styles.columnText}>
            {moment(showAnnouncement.updatedTime).format('YYYY-MM-DD HH:mm:ss')}
          </div>
        </div>
      </Dialog>

      {/* 新增/編輯公告 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addAnnouncementDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setMessageStatus(false);
          setAnnouncementDialog(false);
        }}
        onClose={() => {
          setMessageStatus(false);
          setAnnouncementDialog(false);
        }}
      >
        <h3>{addAnnouncementDataType === 'insert' ? '新增' : '編輯'}公告</h3>
        <Form
          {...layout}
          onFinish={onFinish}
          form={form}
          className={styles.announcementForm}
        >
          <Form.Item
            name="announcementTime"
            label="公告日期"
            rules={[
              {
                required: true,
                message: '請輸入公告日期',
              },
            ]}
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              disabledDate={disabledDate}
              onChange={(value) => setAddAnnouncementTime(value)}
            />
          </Form.Item>
          <Form.Item
            name="fileType"
            label="公告類型"
            rules={[
              {
                required: true,
                message: '請選擇公告類型',
              },
            ]}
          >
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇類型"
              onChange={(value) => setAddAnnouncementType(value)}
            >
              <Select.Option value="img">圖片</Select.Option>
              <Select.Option value="file">檔案</Select.Option>
              <Select.Option value="text">文字</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="type"
            label="公告類別"
            rules={[
              {
                required: true,
                message: '請選擇公告類別',
              },
            ]}
          >
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇類別"
            >
              {categoryDataArr.map((category) => (
                <Select.Option key={category.id} value={category.name}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="title"
            label="公告標題"
            rules={[
              {
                required: true,
                message: '請輸入公告標題',
              },
            ]}
          >
            <Input
              name="title"
              placeholder="請輸入標題"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
            />
          </Form.Item>
          <Form.Item
            name="content"
            label="公告內容"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input.TextArea
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
            />
          </Form.Item>
          <Form.Item
            name="endTime"
            label="公告截止"
            rules={[
              {
                required: false,
                message: '請輸入公告截止日期',
              },
            ]}
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              disabledDate={(date) => {
                return date.valueOf() <= moment(announcementTime).valueOf();
              }}
            />
          </Form.Item>
          <Form.Item
            name="checkedStatus"
            label="公告置頂"
            valuePropName="checked"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Checkbox className={styles.checkbox} label="置頂(重要公告)" />
          </Form.Item>
          {addAnnouncementType !== 'text' && (
            <Form.Item
              name="files"
              valuePropName="fileList"
              label={
                form.getFieldValue('fileType') === 'img'
                  ? '圖片上傳'
                  : '檔案上傳'
              }
              getValueFromEvent={(e) => {
                const { fileList } = e;
                setAnnouncementFile(fileList);
                return fileList;
              }}
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      if (
                        value.map((item) => item.status).includes('uploading')
                      ) {
                        return Promise.reject(new Error('上傳中'));
                      }
                      if (value.map((item) => item.status).includes('error')) {
                        return Promise.reject(
                          new Error('上傳失敗，請重新上傳或者移除檔案')
                        );
                      }
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Upload
                fileList={form.getFieldValue('files')}
                accept={
                  form.getFieldValue('fileType') === 'img'
                    ? 'image/*'
                    : '.doc,.docx,.pdf'
                }
                customRequest={async (options) => {
                  const { onSuccess, file } = options;
                  if (file.size > 1024 * 1024 * 20) {
                    Message.error('上傳檔案不能超過20MB');
                    return;
                  }
                  try {
                    const res = await uploadFiles('announcement', options.file);
                    onSuccess(res.data.length > 0 ? res.data[0] : res.data);
                  } catch (err) {
                    console.log(err);
                  }
                }}
                onRemove={async (file) => {
                  try {
                    await deleteFile(file);
                  } catch (err) {
                    console.error({ err });
                  }
                }}
              >
                <Button>上傳</Button>
              </Upload>
            </Form.Item>
          )}

          <Form.Item
            name="calendarStatus"
            label="發佈行事曆"
            valuePropName="checked"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch
              className={styles.messageSwitch}
              checkedChildren="發佈"
              unCheckedChildren="不發佈"
            />
          </Form.Item>
          {(form.getFieldValue('fileType') === 'img' ||
            updateAnnouncementObj.fileType === 'img') &&
            announcementFile.length > 0 &&
            allowedFuncs.includes('公播管理') && (
              <Form.Item
                label="發佈公播"
                valuePropName="checked"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Switch
                    checked={broadcastStatus}
                    className={styles.messageSwitch}
                    checkedChildren="發佈"
                    unCheckedChildren="不發佈"
                    onChange={(checked) => {
                      console.log(checked);
                      setBroadcastStatus(checked);
                    }}
                  />
                  {broadcastStatus && (
                    <Radio.Group
                      value={broadcastGroup}
                      style={{ marginLeft: 10 }}
                      onChange={(e) => {
                        setBroadcastGroup(e.target.value);
                      }}
                    >
                      <Radio value="one">公播列表</Radio>
                      <Radio value="more">公播群組</Radio>
                    </Radio.Group>
                  )}
                </div>
              </Form.Item>
            )}

          {broadcastStatus === true && broadcastGroup === 'more' && (
            <Form.Item
              name="broadcastGroupId"
              label="公播群組"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select>
                {/* <Select.Option value="one">單獨發佈</Select.Option> */}
                {broadcastData.map((item, index) => (
                  <Select.Option value={item._id} key={index}>
                    {item.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item
            label="發佈推播"
            name="MessageStatus"
            valuePropName="checked"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch
              className={styles.messageSwitch}
              checkedChildren="開啟推播"
              unCheckedChildren="關掉推播"
              onChange={(checked) => {
                if (checked === true) {
                  setMessageStatus(true);
                } else {
                  setMessageStatus(false);
                  setAllows([]);
                }
              }}
            />
          </Form.Item>
          {form.getFieldValue('MessageStatus') && messageStatus && (
            <Form.Item
              name="allows"
              label="推播住戶"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Checkbox.Group
                className={styles.optionList}
                itemDirection="ver"
                dataSource={allowsCheckBox()}
                onChange={async (value) => {
                  const res = await residentAccountNumbers.find({
                    query: { building: { $in: value } },
                  });
                  setAllows(res.data.map((item) => item.householdNumber));
                }}
              />
            </Form.Item>
          )}
        </Form>
      </Dialog>

      <div className={styles.container}>
        <div className={styles.btnBox}>
          <Button
            className={styles.btnItem1}
            onClick={() => {
              form.resetFields();
              setAnnouncementDialog(true);
              setAddAnnouncementDataType('insert');
              setBroadcastStatus(false);
            }}
          >
            新增公告
          </Button>
          <EditCategories
            {...{
              categoryName: '公告類別',
              buttonLabel: '公告類別管理',
              dialogTitle: '公告類別管理',
              onUpdate: () => {
                setIsUpdate((prev) => !prev);
              },
            }}
          />
        </div>
        <div className={styles.btnBox}>
          <div>
            類別：
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇類別"
              onChange={(type) => {
                setCurrentPage(1);
                setAnnouncementType(type);
              }}
              value={announcementType}
            >
              {categoryDataArr.map((category) => (
                <Select.Option key={category.id} value={category.name}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div style={{ marginLeft: 10 }}>
            公告時間：
            <RangePicker
              value={currentAnnouncementDateRange}
              onChange={(dates) => {
                const startDate = dates[0];
                const endDate = dates[1];
                if (dates.length === 0 || (startDate && endDate)) {
                  setCurrentPage(1);
                }
                setCurrentAnnouncementDateRange(dates);
              }}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            關鍵字:
            <Input
              placeholder="請輸入關鍵字"
              value={currentInputKeyword}
              onChange={setCurrentInputKeyword}
              hasClear
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            狀態:
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇狀態"
              value={
                announcementStatus === '未截止'
                  ? 'false'
                  : announcementStatus === '已截止'
                  ? 'true'
                  : undefined
              }
              onChange={(value) => {
                setCurrentPage(1);
                setAnnouncementStatus(
                  value === 'true'
                    ? '已截止'
                    : value === 'false'
                    ? '未截止'
                    : undefined
                );
              }}
            >
              <Select.Option value="true">已截止</Select.Option>
              <Select.Option value="false">未截止</Select.Option>
            </Select>
          </div>
        </div>
        <Card free>
          <Card.Content>
            <Table
              dataSource={announcementList}
              onSort={onTableSort}
              sort={{ [currentDataIndex]: currentOrder }}
            >
              <Table.Column
                lock="left"
                sortable
                title="建立時間"
                dataIndex="createdTime"
                width={200}
                cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
              />
              <Table.Column
                sortable
                title="公告單位"
                dataIndex="announcer"
                width={100}
              />
              <Table.Column
                sortable
                title="公告時間"
                dataIndex="announcementTime"
                cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
                width={200}
              />
              <Table.Column
                sortable
                title="類別"
                dataIndex="type"
                width={100}
              />
              <Table.Column
                sortable
                title="標題"
                dataIndex="title"
                width={100}
              />

              <Table.Column
                sortable
                title="狀態"
                dataIndex="endTime"
                width={120}
                cell={(value) =>
                  !value || value > moment().valueOf() ? '未截止' : '已截止'
                }
              />

              <Table.Column
                title="檔案"
                width={200}
                cell={(_value, _index, record) => {
                  if (record.files) {
                    return (
                      <>
                        {record.files.map((list, index) => {
                          return (
                            <a
                              style={
                                list === ''
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }
                              target="_blank"
                              rel="noreferrer"
                              key={index}
                              href={list.response.showPath}
                            >
                              <span
                                role="img"
                                aria-label="spin"
                                aria-labelledby=""
                              >
                                📎
                              </span>
                              {` 附件${index + 1}`}
                            </a>
                          );
                        })}
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={250}
                lock="right"
                cell={(_value, _index, record) => {
                  return (
                    <div className={styles.btn}>
                      <Button
                        type="secondary"
                        onClick={() => {
                          setPreviewSingleDialog(true);
                          setShowAnnouncement(record);
                        }}
                      >
                        查看
                      </Button>
                      <Button
                        type="normal"
                        onClick={() => {
                          console.log(record);
                          setAnnouncementDialog(true);
                          // setAddAnnouncementType(record.fileType);
                          setAddAnnouncementDataType('update');
                          setAddAnnouncementId(record._id);
                          setUpdateAnnouncementObj(record);
                          setBroadcastStatus(record.broadcastStatus);
                          setBroadcastGroup(record.broadcastGroup);
                          setAnnouncementFile(record.files);
                          setAddAnnouncementType(record.fileType);
                          setAddAnnouncementTime(
                            moment(record.announcementTime)
                          );
                          form.setFieldsValue({
                            ...record,
                            announcementTime: moment(record.announcementTime),
                            endTime: moment(record.endTime),
                          });
                        }}
                      >
                        編輯
                      </Button>

                      <Button
                        type="primary"
                        warning
                        onClick={async () => {
                          const item = record;
                          const result = await Swal.fire({
                            title: `確定刪除標題(${record.title})公告?`,
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          });
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此公告已刪除', 'success');
                            const promise = [];
                            if (item.files.length > 0) {
                              for (let i = 0; i < item.files.length; i++) {
                                promise.push(
                                  client
                                    .service('uploads')
                                    .remove(item.files[i].response._id)
                                );
                              }
                              await Promise.all(promise);
                            }
                            await announcement.remove(item._id);
                            const prePages =
                              currentPage - 1 >= 0 ? currentPage - 1 : 0;
                            if (announcementList.length - 1 <= prePages * 10) {
                              setCurrentPage(
                                currentPage - 1 < 1 ? 1 : currentPage - 1
                              );
                            }
                            setIsUpdate((pre) => !pre);
                            if (item.broadcastGroupId) {
                              const broadcastId = await broadcast.find({
                                query: { announcementId: item._id },
                              });
                              await broadcast.remove(broadcastId.data[0]._id);
                            }
                            if (item.calendarStatus) {
                              await calendar.remove(item.calendarId);
                            }
                          }
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              />
            </Table>

            <Pagination
              className={styles.pagination}
              total={total}
              pageSize={10}
              current={currentPage}
              totalRender={(total) => `Total: ${total}`}
              onChange={(pageNumber) => {
                setCurrentPage(pageNumber);
              }}
            />
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default AnnouncementList;
